import useQueryData from "hooks/useQueryData";
import { GET_PROFILE_COUNT_FOR_SKILLS } from "graphql/queries";

/**
 * @description Custom hook to get the count of profiles for a given set of skills
 */
export default function useSkillsMatch({ skills, skip = false }) {
  const { loading, data, error } = useQueryData({
    queryName: GET_PROFILE_COUNT_FOR_SKILLS,
    keyName: "profileCountForSkills",
    skip: !skills || skills.length === 0 || skip,
    variables: {
      skills,
    },
  });

  return {
    loading,
    count: data?.profileCountForSkills?.count,
    error,
  };
}
